<form class="licence-form" *ngIf="!isLoading && isFormInit" [formGroup]="licenceForm" (submit)="onSubmit()">
    <fieldset>
        <legend>{{ 'users.licenceForm.licenceInfo.fullLabel' | translate }}</legend>

        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.name.label.shortLabel' | translate }}
            </mat-label>
            <input type="text" matInput formControlName="name" name="name" required>
            <mat-error>{{ 'users.licenceForm.name.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'main.languageSelector.shortLabel' | translate }}</mat-label>
            <mat-select formControlName="lang" name="lang" required>
                <mat-option *ngFor="let language of languageList" [value]="language.code">
                    {{ language.codeISO }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'users.licencesList.type.shortLabel' | translate }}
            </mat-label>
            <mat-select formControlName="licenceType" name="licenceType">
                <mat-option *ngFor="let licenceType of licenceTypes" [value]="licenceType.code">
                    {{ licenceType.text.shortLabel }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <div>
            <mat-checkbox name="isPublic" formControlName="isPublic">
                {{ 'users.licencesList.isPublic.shortLabel' | translate }}
            </mat-checkbox>
        </div>

    </fieldset>

    <fieldset>
        <legend>{{ 'users.licenceForm.townInfo.fullLabel' | translate }}</legend>

        <mat-form-field *ngIf="licence">
            <mat-label>{{ 'users.licenceForm.town.label.shortLabel' | translate }}
            </mat-label>
            <input type="text" matInput formControlName="organism" name="organism">
        </mat-form-field>

        <mat-form-field class="origin-field" *ngIf="!licence">
            <input type="text" matInput formControlName="organism" name="organism" [matAutocomplete]="auto" required>
            <mat-label>{{'users.licenceForm.town.label.shortLabel' | translate}}
            </mat-label>
            <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
                <mat-option *ngFor="let organism of filteredOrganisms | async" [value]="organism">
                    {{organism.text.fullLabel}}
                </mat-option>
            </mat-autocomplete>
            <mat-error>{{ 'users.licenceForm.town.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.accountNumber.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="accountNumber" name="accountNumber" required>
            <mat-error>{{ 'users.licenceForm.accountNumber.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.businessNumber.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="businessNumber" name="businessNumber">
            <mat-error>{{ 'users.licenceForm.businessNumber.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

    </fieldset>

    <fieldset>
        <legend>{{ 'users.licenceForm.address.label.fullLabel' | translate }}</legend>

        <mat-form-field class="triple">
            <mat-label>{{ 'users.licenceForm.address.street.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="addressStreet" name="addressStreet" required>
            <mat-error>{{ 'users.licenceForm.address.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <br />

        <mat-form-field class="mini">
            <mat-label>{{ 'users.licenceForm.address.number.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="addressNumber" name="addressNumber" required>
            <mat-error>{{ 'users.licenceForm.address.number.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field class="mini">
            <mat-label>{{ 'users.licenceForm.address.box.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="addressBox" name="addressBox">
        </mat-form-field>

        <mat-form-field class="mini">
            <mat-label>{{ 'users.licenceForm.address.postalCode.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="addressPostalCode" name="addressPostalCode" required>
            <mat-error>{{ 'users.licenceForm.address.postalCode.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

        <mat-form-field>
            <input type="text" matInput required
                formControlName="addressMunicipality" name="addressMunicipality">
            <mat-label>{{'users.licenceForm.address.municipality.label.shortLabel' | translate}}
            </mat-label>
            <mat-autocomplete #auto="matAutocomplete">
                <mat-option *ngFor="let municipality of municipalities | async" [value]="addressMunicipality">
                    {{municipality.text.fullLabel}}
                </mat-option>
            </mat-autocomplete>
            <mat-error>{{ 'users.licenceForm.address.errorMessage.summary' | translate }}</mat-error>
        </mat-form-field>

    </fieldset>

    <fieldset>
        <legend>{{ 'users.licenceForm.contractInfo.fullLabel' | translate }}</legend>
        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.banker.label.shortLabel' | translate }}</mat-label>
            <mat-select formControlName="banker" name="banker">
                <mat-option *ngFor="let banker of bankers" [value]="banker.username">
                    {{ banker.username }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="!licence">
            <mat-label>{{ 'users.licenceForm.licenceTerm.label.shortLabel' | translate }}</mat-label>
            <mat-select *ngIf="isTestLicence" [value]="0" [disabled]="true">
                <mat-option [value]="0" [disabled]="true">
                    {{ '14 ' + ('users.licenceForm.licenceTerm.days.shortLabel' | translate) }}
                </mat-option>
            </mat-select>
            <mat-select *ngIf="!isTestLicence" formControlName="licenceTerm" name="licenceTerm">
                <mat-option *ngFor="let licenceTerm of licenceTerms" [value]="licenceTerm.yearTerm">
                    {{ licenceTerm.label }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field *ngIf="licence">
            <mat-label>{{ 'users.licenceForm.endDate.label.shortLabel' | translate }}</mat-label>
            <input matInput [matDatepicker]="endDatepicker" formControlName="endDate" name="endDate">
            <mat-datepicker-toggle matSuffix [for]="endDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #endDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field *ngIf="licence">
            <mat-label>{{ 'users.licencesList.terminationDate.shortLabel' | translate }}</mat-label>
            <input matInput [matDatepicker]="terminationDatepicker" formControlName="terminationDate"
                name="terminationDate"(selectionChange)="onTerminationDateChanged($event.value)">
            <mat-datepicker-toggle matSuffix (click)="clearTerminationDate()" *ngIf="hasTerminationDate">
                <mat-icon matDatepickerToggleIcon>clear</mat-icon>
            </mat-datepicker-toggle>
            <mat-datepicker-toggle matSuffix [for]="terminationDatepicker"></mat-datepicker-toggle>
            <mat-datepicker #terminationDatepicker></mat-datepicker>
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.payMode.label.shortLabel' | translate }}</mat-label>
            <mat-select name="isAutomaticallyDebited" formControlName="isAutomaticallyDebited" required>
                <mat-option [value]="false">
                    {{ 'users.licencesList.billing.shortLabel' | translate }}
                </mat-option>
                <mat-option [value]="true">
                    {{ 'users.licencesList.isAutomaticallyDebited.shortLabel' | translate }}
                </mat-option>
            </mat-select>
        </mat-form-field>

        <br />

        <mat-form-field class="triple">
            <mat-label>{{ 'users.licenceForm.communication.label.shortLabel' | translate }}</mat-label>
            <input type="text" matInput formControlName="communication" name="communication">
        </mat-form-field>
        <mat-form-field>
            <mat-label>{{ 'users.licenceForm.billingMonth.fullLabel' | translate }}</mat-label>
            <mat-select name="billingMonth" formControlName="billingMonth">
                <mat-option [value]="0">{{ 'users.licenceForm.default.shortLabel' | translate }}</mat-option>
                <mat-option [value]="1">{{ 'users.licenceBilling.april.shortLabel' | translate }}</mat-option>
                <mat-option [value]="2">{{ 'users.licenceBilling.october.shortLabel' | translate }}</mat-option>
            </mat-select>
        </mat-form-field>

    </fieldset>

    <section class="actions">
        <button *ngIf="!isLoading" type="submit" mat-icon-button color="accent" [disabled]="licenceForm.invalid">
            <mat-icon aria-label="Validate">check</mat-icon>
        </button>
        <button *ngIf="!isLoading" type="button" mat-icon-button (click)="onCancel()">
            <mat-icon aria-label="Cancel">clear</mat-icon>
        </button>
    </section>
</form>
<mat-spinner *ngIf="isLoading" [diameter]="35" color="accent"></mat-spinner>
